export default __webpack_public_path__ + "static/media/no-image-found.298b9820.png";